export default {
  data: () => ({
    expanded: [],
  }),
  methods: {
    hideExpandBy(ID) {
      let expandIndex = this.expanded.findIndex(item => item.ID === ID)
      if(expandIndex < 0) return
      this.expanded.splice(expandIndex, 1)
    },

    updateTableDataBy(item, candidate) {
      item.merge(candidate)
      // item.requests = candidate.requests
    },

    goToEdit({expand, isExpanded}) {
      if(this.$refs.expand) {
        if(this.$refs.expand.model && this.$refs.expand.model.editing) {
          let goToEdit = () => {
            setTimeout(() => {
              expand(!isExpanded);
            }, 0);
          } ;
          this.$refs.expand.goBackHandler(goToEdit);
          return;
        }
      }
      expand(!isExpanded);
    },
  },

}
